module.exports = __webpack_public_path__ + "static/img/erpm2.6f3180b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erpm2.png
// module id = xBAm
// module chunks = 73